import dynamic from 'next/dynamic'

const MainContainer = dynamic(() => import('../../components').then(mod => mod.MainContainer))
const MediaGridImages = dynamic(() => import('../../components').then(mod => mod.MediaGridImages))
const HeroSlider2 = dynamic(() => import('../../components').then(mod => mod.HeroSlider2))

import { isObjectEmpty } from '../../utils'
import { fetchPageByGql } from '../../services'
import { PAGE_PROJECTS } from '../../services/queries/pages'
import getGlobalData from '../../services/cacheGlobalData'
import { STATIC_PAGE_WP_IDS } from '../../utils/siteConfig'

/**
 * Fixed Page - Projects
 */
export default function Contact({ pageData, homeData, projectsListData }) {
  const header = homeData?.dovetailPageHome?.header
  const testimonialsContent = homeData?.dovetailPageHome?.testimonialsContent

  let sliderItems = []
  if (header && header.slider.length) {
    header.slider.forEach((item) => {
      const card = item?.showInfobox
        ? {
            title: item?.title,
            date: item?.date,
            description: item?.description,
          }
        : false

      const content = {
        project: item?.showCta ? item?.link?.label : false,
        projectLabel: "Project:",
        status: item.status,
        statusLabel: "Status:",
        src: item.image.sourceUrl,
        alt: item.image.altText,
        srcMobile: item?.imageMobile?.sourceUrl,
        altMobile: item?.imageMobile?.altText,        
        href: item.link.type == 'external' ? item.link.externalUrl : (item.link.url ? item.link.url : '#'),
        target: item.link.target,
        card: card
      }
      sliderItems.push(content)
    })
  }
  
  return (
    <MainContainer>
      {/* <HeroSlider2 sliderItems={sliderItems} /> */}

      <div className={'hero-pt mb-65 md:mb-0'}>
        <MediaGridImages        
          heading={pageData?.dovetailPageProjects?.title}
          subHeading={pageData?.dovetailPageProjects?.headline}
          description={pageData?.dovetailPageProjects?.description}
          projects={projectsListData}
          signatureProjects={pageData?.dovetailPageProjects?.signatureProjects}
        />
      </div>

      <div className='md:-mt-60'>
        <MediaGridImages
          testimonials={true}
          isSmallTestimonial={true}
          heading={testimonialsContent?.title}
          subHeading={testimonialsContent?.headline}
          description={'&nbsp;'}
          projects={testimonialsContent?.items.map((item) => {
            return {
              "testimonial": {
                "quote": item?.testimonial,
                "name": item?.name
              },
              "SingleProjectFields": {
                "headerImage": item?.image 
              }
            }
          })}
        />
      </div>
    </MainContainer>
  )
}

export async function getStaticProps({ preview = false }) {
  const query = PAGE_PROJECTS
  const params = {
    pageId: STATIC_PAGE_WP_IDS?.projects,
    homeId: STATIC_PAGE_WP_IDS?.home
  }

  const responseData = await fetchPageByGql(query, params, preview)
  
  const pageData = responseData?.pageData || {}
  const homeData = responseData?.homeData || {}
  const projectsListData = responseData?.projectsList?.nodes || []

  const globalData = await getGlobalData()

  return isObjectEmpty(pageData)
    ? { notFound: true } // returns custom 404 page
    : { props: { preview, pageData, homeData, projectsListData, globalData } }
}
